import { api, type ApiType } from 'lib/api';
import { stringParse } from 'utils';

export const apiUsers: ApiType = {
  get: {
    list: ({ query }) => api.get('/api/users', query),
    search: ({ query, vars }) =>
      api.get(stringParse('/api/users?search={0}&organizationId={1}', vars), query),
    loggedInUser: () => api.get('/LoggedInUser'),
    featureFlags: () => api.get('/FeatureFlags'),
  },
  put: {},
  post: {},
  delete: {},
};
